import { render } from "./SearchPeople.vue?vue&type=template&id=74d11a33"
import script from "./SearchPeople.vue?vue&type=script&lang=js"
export * from "./SearchPeople.vue?vue&type=script&lang=js"

import "./SearchPeople.vue?vue&type=style&index=0&id=74d11a33&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__